// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"61de11ec","453":"d855a71b","455":"3c12f8a6"}[chunkId] + ".chunk.js";
};